
import { EventEmitter } from 'events';

import server from 'server';

import { MyRgsProfile } from 'myrgs-profile';

export class UpdatableMyRgsProfile extends MyRgsProfile {
	constructor () {
		super(...arguments);

		this._events = new EventEmitter;

		this.update = this.update.bind(this);
		this.updateAtLeastOnce = this.updateAtLeastOnce.bind(this);
		this._updateAtLeastOnce = null;
	}

	update (response) {
		if (arguments.length === 0) {
			const updatePromise = this._updateFromGetInfo();
			this._updateAtLeastOnce = this._updateAtLeastOnce || updatePromise;
			return updatePromise;
		}
		const updatePromise = this._updateFromResponse(response);
		this._updateAtLeastOnce = this._updateAtLeastOnce || updatePromise;
		return updatePromise;
	}

	updateAtLeastOnce () {
		if (!this._updateAtLeastOnce) {
			this._updateAtLeastOnce = this._updateFromGetInfo();
		}

		return this._updateAtLeastOnce;
	}

	// RGSSUP-12253
	// getUserProfileSummary берет данные из текущей сессии, в которой, после смены даннх в БД, старые данные и остаются
	// Сделано получение всегда актуальных данных, а не данных из сессии (обновление сессии при запросе данных о юзере)
	_updateFromGetInfo () {
		return server.my.cmsapi.lk.getUserProfileSummary()
			.then( response => {
				if (this._getIsAuthenticatedFromResponse(response)) {
					return server.my.cmsapi.lk.updateUserProfileSummary();
				}
				return response;
			})
			.then(this._updateFromResponse.bind(this));
	}

	_updateFromResponse (response) {
		const { responseJSON } = response;

		this.fromJS(responseJSON);

		this.IsAuthenticated.fromJS(this._getIsAuthenticatedFromResponse(response));

		return response;
	}

	_getIsAuthenticatedFromResponse (response) {
		const { responseJSON } = response;

		return 'IsAuthenticated' in responseJSON
			? responseJSON.IsAuthenticated
			: Boolean(responseJSON.UserProfileID);
	}
}

export const profile = new UpdatableMyRgsProfile;

/**
 * @deprecated Use `profile` instead
 */
export const user = profile;

/**
 * @deprecated import { MyRgsProfile } from 'myrgs-profile' instead
 */
export { MyRgsProfile };
